import React, { useEffect, useState, useRef, useContext } from 'react';
import Link from 'next/link';
import Slider from '../../CustomSlider';
import Product from '../../Product';
import NoProductAvailable from '../../no-products-available';
import { shopFullMenu } from '../../../constants/segmentSource';
import { ASAP } from '../../../constants/deliveryType';
import appContext from '../../../Context/appContext';
import GrassdoorSecondaryBanners from './GrassdoorSecondaryBanners';
import ReferralAndFnFBannerData from '../../../constants/ReferralAndFnFBannerData';
import BrandMenu from '../BrandMenu';
import BottomCatalog from './BottomCatalog';
import * as WEBSITES from '../../../constants/website';
import SimilarProducts from '../../searchModule/SimilarProducts';
import { useDispatch, useSelector } from 'react-redux';
import { setPositionID } from '../../../redux/slices/otherSlice';
// import IndividualCategory from './IndividualCategory';

const productSliderDesktop = {
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 3,
  arrows: true,
  centerMode: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: true
      }
    }
  ]
};


// const ViewAllLink = ({ slug, tab, categoryID, link }) => {
//   let url = link && link !== '' ? { pathname: link, query: { tab } } : { pathname: `/shop/${slug}`, query: { tab } };
//   if (link && (link.indexOf('tab=schedule') !== -1 || link.indexOf('tab=asap') !== -1)) {
//     url = link;
//   }
//   const { dispatch } = useContext(appContext);
//   function saveCategoryPosition() {
//     dispatch({ type: 'setPositionID', payload: { position: categoryID } });
//   }
//   return (
//     <div className="col-3 d-flex justify-content-end">
//       <Link prefetch={false} href={url}>
//         <a onClick={saveCategoryPosition} className="view-all">
//           View All
//           {/* <i className="icon-chevron-right-f" /> */}
//         </a>
//       </Link>
//     </div>
//   );
// };

const IndividualCategory = ({
  data,
  currentTab,
  categoryIndex,
  showViewAll,
  setTrack,
  initialLocationAddress,
  initialFreightLimit,
  initialPurchaseLimit,
  initialUpsellProducts,
  initialDeliveryAddressDetails,
  isSearchPage = false,
  hideSlider = false,
  isSearchedProducts = false,
  isSimlarProduct = false,
  setSimlarProductsLoading
}) => {

  let link = data.category_view_all;
  if (link && link !== '' && link.toLowerCase().indexOf('http://') == -1 && link.toLowerCase().indexOf('https://') == -1) {
    link = `https://${link}`;
  }

  const [showCategory, setShowCategory] = useState(categoryIndex == 0);
  const categoryRef = useRef();

  // const {
  //   state: {
  //     positionID
  //   },
  //   dispatch
  // } = useContext(appContext);
  const positionID = useSelector(state => state.other?.positionID)
  const dispatchRedux = useDispatch()

  useEffect(() => {
    const currentScrollPosition = `cat_${data.id}`;
    if (positionID && positionID == currentScrollPosition) {
      const elem = document.getElementById(positionID);
      if (elem) {
        // elem.scrollIntoView({
        //   behavior: 'smooth',
        //   block: 'center',
        //   inline: 'center'
        // });
      }
      // dispatch({ type: 'setPositionID', payload: { position: null } });

      dispatchRedux(setPositionID({ position: null }))
    }
  }, []);

  useEffect(() => {
    const currentRef = categoryRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // do your actions here
          setShowCategory(true);
        } else {
          // setShowCategory(false);
        }
      },
      {
        root: null,
        rootMargin: '500px',
        threshold: 0.1
      }
    );
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      observer.unobserve(currentRef);
    };
  }, [data]);

  useEffect(() => {
    const currentRef = categoryRef.current;
    const observer = new IntersectionObserver(
      entries =>
        entries.forEach(entry => {
          const currentY = entry.boundingClientRect.y;
          if (entry.isIntersecting) {
            if (currentY > 0 && setTrack) {
              setTrack(data, categoryIndex);
            }
          }
        }),
      {
        root: null,
        rootMargin: '100px',
        threshold: 0.1
      }
    );
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      observer.unobserve(currentRef);
    };
  }, [data.id]);

  function renderProducts(
    products,
    categorySlug,
    initialLocationAddress = false,
    initialFreightLimit = false,
    initialPurchaseLimit = false,
    initialUpsellProducts = false,
    initialDeliveryAddressDetails = false,
    isSearchPage,
    isSearchedProducts,
    isSimlarProduct,
    setSimlarProductsLoading
  ) {
    if (products && products.length > 0) {
      return products.map((item, productIndex) => {
        return (
          item ?
            <>
              <Product
                page={currentTab == ASAP ? 'ASAP List' : 'Schedule List'}
                productIndex={productIndex}
                categoryIndex={categoryIndex}
                key={`product_list_${item.product_id || item.bundle_id}`}
                data={item}
                inShop
                categorySlug={item.category_slug || categorySlug}
                source={shopFullMenu}
                categoryID={data.id || data.category_id}
                openInPopup
                initialLocationAddress={initialLocationAddress}
                initialFreightLimit={initialFreightLimit}
                initialPurchaseLimit={initialPurchaseLimit}
                initialUpsellProducts={initialUpsellProducts}
                initialDeliveryAddressDetails={initialDeliveryAddressDetails}
                isSearchPage={isSearchPage}
                hideSlider={hideSlider}
                isSearchedProducts={isSearchedProducts}
                isSimlarProduct={isSimlarProduct}
                setSimlarProductsLoading={setSimlarProductsLoading}
              />
            </> : null

        );
      });
    }
    return null;
  }

  return (
    <div
      ref={categoryRef}
      id={`cat_${data.id || data.category_id}`}
      key={`cat_${data.id || data.category_id}`}
      className="product-category lazy-load-category-height"
    >
      {showCategory ? (
        <>
          {/* <div className="row ">
            <div className="col-9 ">
              <h3 className=" h4 a-category-name bold">{data.category_name}</h3>
            </div>
            {showViewAll && (
              <ViewAllLink
                categoryID={`cat_${data.id || data.category_id}`}
                slug={data.category_slug}
                tab={currentTab}
                link={link}
              />
            )}
          </div> */}
          {/* <h6 className="description mb-0 mt-2">{data.category_description}</h6>
          {data.category_offer_description && (
            <em>
              <div className="mini-description mt-1 mb-3">{data.category_offer_description}</div>
            </em>
          )}
          {data.category_sale_description && (
            <em>
              <div className="mini-description mt-1 mb-3">{data.category_sale_description}</div>
            </em>
          )} */}
          {data.products?.length &&

            hideSlider ?
            <div className='v-list product-category mt-2'>
              {renderProducts(
                data.products,
                data.category_slug,
                initialLocationAddress,
                initialFreightLimit,
                initialPurchaseLimit,
                initialUpsellProducts,
                initialDeliveryAddressDetails,
                isSearchPage,
                isSearchedProducts,
                isSimlarProduct,
                setSimlarProductsLoading
              )}
            </div> :
            <div className={`${isSimlarProduct ? 'v-list product-category' : ''} all-products-slider mb-5`}>
              <Slider {...productSliderDesktop}>
                {renderProducts(
                  data.products,
                  data.category_slug,
                  initialLocationAddress,
                  initialFreightLimit,
                  initialPurchaseLimit,
                  initialUpsellProducts,
                  initialDeliveryAddressDetails,
                  isSearchPage,
                  isSearchedProducts,
                  isSimlarProduct,
                  setSimlarProductsLoading
                )}
              </Slider>
            </div>
          }
        </>
      ) : (
        <>
          {!process.browser && (
            <>
              <div className="row">
                <h5 className="semi-bold col-9">{data.category_name}</h5>
                <a
                  href={link && link !== '' ? link : `/shop/${data.category_slug}?tab=${currentTab}`}
                  className="view-all col-3 d-flex justify-content-end"
                >
                  View All
                </a>
              </div>

              <h6 className="description mb-0 mt-2">{data.category_description}</h6>
              {data.category_offer_description && (
                <em>
                  <div className="mini-description mt-1">{data.category_offer_description}</div>
                </em>
              )}
              {data.category_sale_description && (
                <em>
                  <div className="mini-description mt-1">{data.category_sale_description}</div>
                </em>
              )}
              <div className="d-flex skeleton-product-list" style={{ overflowX: 'auto' }}>
                {data.products.map(product => {
                  return (
                    <a href={`/${product.bundle_id ? 'bundle' : 'product'}/${product.slug}`} className="product skeleton-product">
                      <p className="bold">{product.product_name}</p>
                    </a>
                  );
                })}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default IndividualCategory;